import {LocalizedDictionary} from '../Translator';

export default {
  "DD": "DD",
  "Discontinued": "Снято с производства",
  "Spare part list": "Список запасных частей",
  "Download Excel": "Скачать Excel",
  "Recent search list": "Список последних поисков",
  "No data": "Нет данных",
  "spare part": "запасная часть",
  "none": "нет",
  "no value": "нет значения",
  "No results found": "Результаты не найдены",
  "Spare parts for": "Запасные части для",
  "Could not load cumulated data": "Не удалось загрузить накопленные данные",
  "commissioning part": "пусконаладочная часть",
  "wear part": "быстроизнашивающаяся деталь",
  "Search": "Поиск",
  "Tk": "Тк",
  "Spare part number": "Номер запасной части",
  "drawing": "чертеж",
  "Products for": "Продукты для",
  "Available": "Доступно",
  "MM": "MM",
  "The entered order code is invalid": "Введенный код заказа недействителен",
  "Recommended": "Рекомендуем",
  "No data available for the entered search parameters": "Нет данных для введенных параметров поиска",
  "Search spare parts": "Поиск запасных частей",
  "Order code / product root / serial number": "Код заказа / корень продукта / серийный номер",
  "Characteristic": "Характеристика",
  "Please enter an order code": "Пожалуйста, введите код заказа",
  "Regarding quality- and security-aspects Endress+Hauser strongly recommends the exclusive use of genuine Endress+Hauser spare parts. The instrument may only be maintained and repaired by qualified personnel. The device documentation, applicable standards and legal requirements as well as any certificates have to be observed!": "В отношении качества и безопасности компания Endress+Hauser настоятельно рекомендует использовать исключительно оригинальные запасные части Endress+Hauser. \nОбслуживание и ремонт прибора должен выполнять только квалифицированный персонал. \nНеобходимо соблюдать действующие нормы и требования законодательства, а также сертификаты!",
  "Maintenance advice": "Советы по техническому обслуживанию",
  "Mo.": "Мо.",
  "For which product(s) can my spare part be used? Filling in the spare part order code (e.g. 71002865 or XPD0024) shows the relevant devices this spare part can be used in.": "Для какого продукта (продуктов) можно использовать мою запасную часть? Заполнение кода заказа запасной части (например, 71002865 или XPD0024) показывает, в каких устройствах может использоваться данная запасная часть.",
  "tool": "инструмент",
  "Production numbers": "Производственные номера",
  "New alternative": "Новая альтернатива",
  "There are no items selected. Please use the checkboxes to make your selection": "Не выбрано ни одного элемента. Пожалуйста, воспользуйтесь флажками, чтобы сделать свой выбор",
  "Service segmentation": "Сегментация услуг",
  "Seg": "Seg",
  "Valid": "Действительный",
  "Pos": "Поз",
  "Value": "Значение",
  "service segmentation 2": "Части, требующие базовых знаний. Обязательным условием является успешное прохождение базовой подготовки E+H.",
  "Phase out date": "Дата выхода из эксплуатации",
  "service segmentation 1": "Части, требующие базовых знаний.",
  "Which spare parts are available for my product? Filling in the order code (e.g. FTC260-AA2A1 or PMC51-BA21JB1CGBTDJB) or the product id (e.g. FTC260 or 83F50) shows the relevant spare parts.": "Какие запасные части доступны для моего продукта? Введя код заказа (например, FTC260-AA2A1 или PMC51-BA21JB1CGBTDJB) или идентификатор изделия (например, FTC260 или 83F50), вы найдете соответствующие запасные части.",
  "Set filter": "Установите фильтр",
  "Search date": "Дата поиска",
  "Group": "Группа",
  "Warning": "Внимание",
  "Description": "Описание",
  "Cancel": "Отмена",
  "service segmentation 4": "Детали для ремонта на заводе. Экспертные знания обязательны.",
  "service segmentation 3": "Детали, требующие специальных знаний. Обязательным условием является успешное участие в продвинутом тренинге E+H.",
  "Drawing Position Number": "Номер позиции чертежа",
  "Spare parts search": "Поиск запасных частей",
  "Confirm": "Подтвердите",
  "Ordercode too short": "Код заказа слишком короткий",
  "Product status": "Состояние продукта",
  "Open": "Открыть",
  "Clear": "Очистить",
  "PDF file with assembly instructions": "PDF-файл с инструкциями по сборке",
  "Search products": "Поиск товаров",
  "Export": "Экспорт",
  "Production date": "Дата производства",
  "Order stop": "Остановка заказа",
  "Calibration until": "Калибровка до",
  "PDF file with compatibility information": "Файл PDF с информацией о совместимости",
  "Add selection to cart": "Добавить выбор в корзину",
  "Mounting advices": "Советы по монтажу",
  "Recommended parts only": "Только рекомендуемые детали",
  "not applicable": "не применимо",
  "accessories": "аксессуары",
  "Cumulative spare parts list": "Накопительный список запасных частей",
  "YYYY": "ГГГГ",
  "Title": "Название",
  "Error": "Ошибка",
  "Ordercode too long": "Слишком длинный код заказа",
  "Functions": "Функции",
  "Rec": "Rec",
  "Type": "Тип",
  "Spare sensor until": "Запасной датчик до",
  "Spare parts until": "Запасные части до",
  "Filter": "Фильтр",
  "Check all": "Проверить все",
  "Order code": "Код заказа",
  "Repair until": "Ремонт до",
  "Tag": "Тег",
  "Ok": "Хорошо",
  "Category code": "Код категории",
  "Phase out": "Поэтапно",
  'Compatibility advices': 'Дополнительные документы',
  'Co.': 'Доп. док.',
} as LocalizedDictionary;
